module.exports = __webpack_public_path__ + "img/07-LeProcess-02.8fd2cb7e.png";